export const USER_ME_403_MESSAGE =
    'You have successfully authenticated but are not authorised on CLMi.';
